import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { DataTeamSetupField } from './DataTeamSetupField';

export const DataTeamSetupFieldExtension = FormFieldBlueprint.make({
  name: 'data-team-setup-field',
  params: {
    field: async () =>
      createFormField({
        name: 'DataTeamSetupField',
        component: DataTeamSetupField,
      }),
  },
});
